import React from "react";
import { FaTwitter, FaLinkedin, FaGithub } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="ft-container-1_0_0_">
            <div className="ft-top-1_0_1_">
                {/* Brand */}
                <div className="ft-brand-1_0_2_">
                    <h2>BodhAI</h2>
                    <p className="ft-tagline-1_0_3_">Awaken Your Knowledge</p>
                    <p className="ft-desc-1_0_4_">
                        Empowering students worldwide with AI-driven learning solutions for
                        academic and professional success.
                    </p>
                    <div className="ft-version-1_0_5_">
                        <span className="ft-versionBadge-1_0_6_">v2.1.0</span>
                        <span className="ft-versionStatus-1_0_7_">• Stable Release</span>
                    </div>
                </div>

                {/* Columns */}
                <div className="ft-columns-1_0_8_">
                    <div>
                        <h4>Platform</h4>
                        <ul>
                            <li>About Us</li>
                            <li>Features</li>
                            <li>Pricing</li>
                            <li>Blog</li>
                            <li>Careers</li>
                        </ul>
                    </div>
                    <div>
                        <h4>Support</h4>
                        <ul>
                            <li>
                                <a href="https://support.bodhai.pages.dev">Help Center</a>
                            </li>
                            <li>
                                <a href="https://support.bodhai.pages.dev/contact">Contact Us</a>
                            </li>
                            <li>
                                <a href="https://forum.bodhai.pages.dev">Community</a>
                            </li>
                            <li>
                                <a href="https://status.bodhai.pages.dev">System Status</a>
                            </li>
                            <li>
                                <a href="https://docs.bodhai.pages.dev">Docs</a>
                            </li>
                        </ul>

                    </div>
                    <div>
                        <h4>Legal</h4>
                        <ul>
                            <li><a href="/legal/terms">Terms of Service</a></li>
                            <li><a href="/legal/privacy">Privacy Policy</a></li>
                            <li><a href="/legal/cookies">Cookie Policy</a></li>
                            <li><a href="/legal/security">Security</a></li>
                            <li><a href="/legal/compliance">Compliance</a></li>
                        </ul>

                    </div>
                    <div>
                        <h4>Connect</h4>
                        <ul>
                            <li>Newsletter</li>
                            <li>
                                <a href="https://twitter.com/yourhandle" target="_blank" rel="noreferrer">
                                    Twitter ↗
                                </a>
                            </li>
                            <li>
                                <a href="https://linkedin.com/in/yourhandle" target="_blank" rel="noreferrer">
                                    LinkedIn ↗
                                </a>
                            </li>
                            <li>
                                <a href="https://github.com/yourhandle" target="_blank" rel="noreferrer">
                                    GitHub ↗
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom */}
            <div className="ft-bottom-1_0_9_">
                <p>
                    © {new Date().getFullYear()} BodhAI Technologies Pvt. Ltd. • All
                    rights reserved
                </p>

                <div className="ft-badges-1_0_10_">
                    <span className="ft-badge-1_0_11_">🔒 Secure</span>
                    <span className="ft-badge-1_0_11_">🛡️ Privacy-Focused</span>
                    <span className="ft-badge-1_0_11_">⚡ 99.9% Uptime</span>
                    <span className="ft-badge-1_0_11_">🇮🇳 Made in India</span>
                </div>

                <div className="ft-end-1_0_12_">
                    <div className="ft-social-1_0_13_">
                        <span>Follow us:</span>
                        <a href="https://twitter.com/yourhandle" target="_blank" rel="noreferrer">
                            <FaTwitter />
                        </a>
                        <a href="https://linkedin.com/in/yourhandle" target="_blank" rel="noreferrer">
                            <FaLinkedin />
                        </a>
                        <a href="https://github.com/yourhandle" target="_blank" rel="noreferrer">
                            <FaGithub />
                        </a>
                    </div>


                    <select className="ft-lang-1_0_14_">
                        <option>English (US)</option>
                        <option>हिंदी</option>
                    </select>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
